import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
//redux
import { useDispatch, useSelector } from 'react-redux';
//  api
import { changePassword } from 'api/users';
//slices
import {
  fetchUserInfo,
  updateUserInfo,
} from 'slices/user';
//helper
import { capitalizeText } from 'helpers';
//components
import { InputCustom } from 'components/input';
import Button from 'components/userzone/buttons/ButtonCustom';
import FeedbackStatus from 'components/userzone/FeedbackStatus';

const AccountData = ({ updateData, setUpdateData, disableBtnSave }) => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.user);
  const { t } = useTranslation(['backoffice', 'header', 'register']);
  const [showEditForm, setShowEditForm] = useState(true);
  const [errorChangePass, setErrorChangePass] = useState('');
  const [successChangePass, setSuccessChangePass] = useState(false);
  const [disableBtnChangePass, setDisableBtnChangePass] = useState(false);
  const [showPassForm, setShowPassForm] = useState(false);

  const [formChangePass, setFormChangePass] = useState({
    oldPass: '',
    newPass: '',
    repeatPass: '',
  });


  const validateFullname = updateData?.first_name !== '' && updateData?.last_name !== '';
  const fullname = `${capitalizeText(updateData?.first_name)} ${capitalizeText(updateData?.last_name)}`;

  const handleUpdateUser = async () => {
    try {
      await dispatch(updateUserInfo({ data: updateData, id: userInfo.id })).unwrap();
      dispatch(fetchUserInfo());
    } catch (error) {
      console.error(error);
    }
  };

  const handleCloseToast = () => {
    setSuccessChangePass(false);
  };

  const handleChangePass = async () => {
    setDisableBtnChangePass(true);
    setErrorChangePass('');
    setSuccessChangePass(false);
    const { oldPass, newPass, repeatPass } = formChangePass;
    if (oldPass !== '' && newPass !== '' && repeatPass !== '') {
      if (newPass.length >= 9) {
        if (newPass === repeatPass) {
          const rs = await changePassword(formChangePass);
          if (rs.status === 200) {
            setFormChangePass({
              oldPass: '',
              newPass: '',
              repeatPass: '',
            });
            setShowPassForm(false)
            setSuccessChangePass(true);
          } else if (rs.status === 400) {
            setErrorChangePass(rs.data.msg);
          }
          setDisableBtnChangePass(false);
        } else {
          setErrorChangePass(toString('nocoincidepassword'));
          setDisableBtnChangePass(false);
        }
      } else {
        setErrorChangePass(t('caracteresminimos'));
        setDisableBtnChangePass(false);
      }
    } else {
      setErrorChangePass(t('fieldsrequired', { ns: 'header' }));
      setDisableBtnChangePass(false);
    }
  };

  return (
    <div fluid="true" className="py-3">
      <div className={`${showEditForm ? 'd-block' : 'd-none'}`}>
        <div className="d-flex flex-row flex-nowrap gap-1 section-responsive w-100">
          <p className="mb-0 label-info">
            {t('name')}:
          </p>
          <p>
            {validateFullname ? fullname : '-'}
          </p>
        </div>
        <div className="d-flex flex-row flex-nowrap gap-1 section-responsive w-100">
          <p className="mb-0 label-info">{t('email')}:</p>
          <p>
            {updateData?.email !== '' ? (
              <a href={`mailto:${updateData?.email}`} className="link-email">
                {updateData?.email}
              </a>
            ) : '-'}
          </p>
        </div>
        <div className="d-flex flex-row flex-nowrap gap-1 section-responsive w-100">
          <p className="mb-0 label-info">{t('datebirth', { ns: 'register' })}:</p>
          <p>{updateData?.date_birth !== '' ? updateData?.date_birth : '-'}</p>
        </div>
        <div className="d-flex flex-row flex-nowrap gap-1 section-responsive w-100">
          <p className="mb-0 label-info">{t('telefono')}:</p>
          <p>{updateData?.phone_number !== '' ? updateData?.phone_number : '-'}</p>
        </div>

        {successChangePass && (
          <FeedbackStatus
            feedbackType={'success'}
            isVisible={successChangePass}
            msgObject={t('updatedpassword', { ns: 'register' })}
            onClose={handleCloseToast}
          />
        )}
        <div className="d-flex w-100 justify-content-center justify-content-md-end gap-3 pe-0 pe-md-3">
          <Button
            variant="primary"
            onClick={() => {
              setShowEditForm(false);
              setShowPassForm(false);
            }}
          >
            {t('editar').toUpperCase()}
          </Button>{' '}
          <Button variant="primary" onClick={() => setShowPassForm(!showPassForm)}>
            {t('cambiarcontrasena').toUpperCase()}
          </Button>
        </div>
      </div>
      <div id="password_change" className={`${showPassForm ? 'd-block' : 'd-none'}`}>
        <h2 className="section">{t('cambiarcontrasena')}</h2>
        <Row className="mt-2">
          <Col md={6}>
            <InputCustom
              type="password"
              label={t('currentpassword', { ns: 'header' })}
              className="input-profile"
              value={formChangePass.oldPass}
              placeholder={t('currentpassword', { ns: 'header' })}
              onChange={(e) =>
                setFormChangePass({
                  ...formChangePass,
                  oldPass: e.target.value,
                })
              }
            />
          </Col>
          <Col md={6}>
            <InputCustom
              type="password"
              label={t('newpassword')}
              className="input-profile"
              value={formChangePass.newPass}
              placeholder={t('newpassword')}
              onChange={(e) =>
                setFormChangePass({
                  ...formChangePass,
                  newPass: e.target.value,
                })
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <InputCustom
              type="password"
              label={t('repeatpassword')}
              className="input-profile"
              value={formChangePass.repeatPass}
              placeholder={t('repeatnewpassword', { ns: 'header' })}
              onChange={(e) =>
                setFormChangePass({
                  ...formChangePass,
                  repeatPass: e.target.value,
                })
              }
            />
          </Col>
        </Row>
        {errorChangePass !== '' && (
          <Row className="alert-danger p-0">
            <span className='px-0 text-danger'>{errorChangePass}</span>
          </Row>
        )}
        <div className="d-flex w-100 justify-content-end gap-3">
          <Button variant="secondary" onClick={() => setShowPassForm(false)}>
            {t('cancel')}
          </Button>{' '}
          <Button
            variant="primary"
            className="width-btn-save-profile mt-2"
            loading={disableBtnChangePass}
            onClick={handleChangePass}
          >
            {disableBtnChangePass ? <Spinner animation="border" size="sm" /> : t('save').toUpperCase()}
          </Button>
        </div>

      </div>

      <div id="account_data_edit" className={`${showEditForm ? 'd-none' : 'd-block'}`}>
        <Row>
          <Col md={6}>
            <InputCustom
              type="text"
              className="input-profile"
              label={t('name')}
              placeholder={t('name')}
              title={t('name')}
              value={updateData.first_name}
              onChange={(e) => setUpdateData({ ...updateData, first_name: e.target.value })}
            />
          </Col>
          <Col md={6}>
            <InputCustom
              type="text"
              className="input-profile"
              label={t('lastname', { ns: 'header' })}
              placeholder={t('lastname', { ns: 'header' })}
              title={t('lastname', { ns: 'header' })}
              value={updateData.last_name}
              onChange={(e) => setUpdateData({ ...updateData, last_name: e.target.value })}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <InputCustom
              type="date"
              label={t('birthdate', { ns: 'header' })}
              title={t('birthdate', { ns: 'header' })}
              className="input-profile"
              value={updateData.date_birth}
              onChange={(e) => setUpdateData({ ...updateData, date_birth: e.target.value })}
            />
          </Col>
          <Col md={6}>
            <InputCustom
              type="email"
              className="input-profile"
              label={t('correoelectronico')}
              placeholder={t('correoelectronico')}
              title={t('correoelectronico')}
              value={updateData.email}
              readOnly
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <InputCustom
              type="text"
              className="input-profile"
              label="CIF"
              placeholder="CIF"
              title="CIF"
              value={updateData.dni}
              onChange={(e) => setUpdateData({ ...updateData, dni: e.target.value })}
            />
          </Col>
          <Col md={6}>
            <InputCustom
              type="tel"
              className="input-profile"
              label={t('telefono')}
              placeholder={t('telefono')}
              title={t('telefono')}
              value={updateData.phone_number}
              onChange={(e) => setUpdateData({ ...updateData, phone_number: e.target.value })}
            />
          </Col>
        </Row>

        <div className="d-flex w-100 justify-content-end gap-2 mt-2">
          <Button
            variant="secondary"
            onClick={() => {
              setShowEditForm(true);
            }}
          >
            {t('cancel').toUpperCase()}
          </Button>{' '}
          <Button
            loading={disableBtnSave}
            variant="primary"
            onClick={() => {
              handleUpdateUser();
              setShowEditForm(true);
            }}
          >
            {disableBtnSave ? <Spinner animation="border" size="sm" /> : t('save').toUpperCase()}
          </Button>
        </div>
      </div>
    </div>
  );
};

AccountData.propTypes = {
  updateData: PropTypes.object,
  setUpdateData: PropTypes.func,
  disableBtnSave: PropTypes.bool,
};

export default AccountData;